module.exports = {
    title: '千家悦浏览器',
    tel: '010-82893946',
    supportMail: 'support@qianjiayue.com',
    salestMail: 'sales@qianjiayue.com',
    marketingtMail: 'marketing@qianjiayue.com',

}